import React, { Component } from 'react'
import { connect } from 'react-redux'

// Elements
import Overlay from '../../elements/overlay'

// Components
import Matching from './matching'
import OverlayHeaderBare from '../../components/OverlayHeaderBare'

// Misc.
import { translation } from '../../../utils/helpers'
import './matchingSpareParts.scss'
import Label from '../../elements/label'

class MatchingPartsOverlay extends Component {
  constructor (props) {
    super(props)
    this.state = { }
  }

  renderHeader () {
    let order = this.props.order
    let reportId = order.Report ? order.Report.ReportUid : ''

    return (
      <OverlayHeaderBare overlayId='MatchingPartsOverlay' onClose={this.props.onClose} custom>
        <div className='matchOverlay'>
          <div className='top topHeaderInfo'>
            <div className='matchOverlay__content'>
              <div className='top'>
                <span>{translation(16668)}</span>
              </div>
              <div className='bottom'>
                <Label>{order.InsuranceCompanyName || ''} - {`${translation(459)}: ${reportId}`}</Label>
              </div>
            </div>
          </div>
        </div>
      </OverlayHeaderBare>
    )
  }

  render () {
    return (
      <Overlay overlayId='MatchingPartsOverlay' extraClassName='' noContentScroll>
        {this.renderHeader()}
        <div className='content'>
          {<Matching orderId={this.props.order.Id} />}
        </div>
      </Overlay>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    headerInfo: state.common.headerInfo
  }
}

MatchingPartsOverlay.propTypes = {
  order: React.PropTypes.object.isRequired
}

export default connect(mapStateToProps, {
})(MatchingPartsOverlay)



// WEBPACK FOOTER //
// ./src/app/shared/overlays/matchingSpareParts/index.js